/* ============================================================================
   ToutEn3D — ICÔNES (t3d-icons.js)
   Remplace les émojis par un jeu d'icônes vectorielles maison.

   Pourquoi : un émoji se dessine différemment sur chaque système (Apple,
   Windows, Android), il ne prend pas la couleur de la marque et ne se règle
   par aucun jeton de design. Sur une marque technique, ça fait amateur.

   Le jeu : 24x24, trait 1,6, jointures rondes, currentColor, une seule
   famille et un seul poids. Icônes décoratives donc aria-hidden : le texte
   à côté porte déjà le sens.

   Règle : un conteneur d'icône reçoit un SVG, un émoji au fil du texte est
   simplement retiré. Un libellé de bouton n'a pas besoin d'une icône collée.

   Fichier update-safe. Aucun fichier Dawn ni aucune section n'est modifié :
   tout se fait sur le DOM rendu.
   ========================================================================== */
(function () {
  'use strict';

  var doc = document;

  function svg(inner) {
    return '<svg viewBox="0 0 24 24" width="1em" height="1em" fill="none" ' +
      'stroke="currentColor" stroke-width="1.6" stroke-linecap="round" ' +
      'stroke-linejoin="round" aria-hidden="true" focusable="false" ' +
      'style="display:inline-block;vertical-align:-0.14em">' + inner + '</svg>';
  }

  /* Émoji -> icône. Les clés sont les caractères tels qu'ils sont dans le DOM. */
  var ICONES = {
    /* cotes */
    '\u{1F4D0}': '<path d="M3 8v8M21 8v8M3 12h18"/><path d="M6 10.5v3M18 10.5v3"/>',
    /* usage / validation */
    '✅': '<circle cx="12" cy="12" r="9"/><path d="M8.2 12.4l2.6 2.6 5-5.6"/>',
    /* piece jointe */
    '\u{1F4CE}': '<path d="M17 8.6v6.9a5 5 0 0 1-10 0V7a3.5 3.5 0 0 1 7 0v8.2a2 2 0 0 1-4 0V8.6"/>',
    /* volume 3D */
    '\u{1F9CA}': '<path d="M12 2.8l8.2 4.5v9.4L12 21.2 3.8 16.7V7.3z"/><path d="M3.8 7.3l8.2 4.5 8.2-4.5M12 11.8v9.4"/>',
    /* quantite */
    '\u{1F522}': '<path d="M12 3l8.5 4.3L12 11.6 3.5 7.3z"/><path d="M3.5 12.1l8.5 4.3 8.5-4.3M3.5 16.7L12 21l8.5-4.3"/>',
    /* texture */
    '\u{1F590}': '<path d="M3 8c3-2.4 6 2.4 9 0s6-2.4 9 0M3 13c3-2.4 6 2.4 9 0s6-2.4 9 0M3 18c3-2.4 6 2.4 9 0s6-2.4 9 0"/>',
    /* matiere vegetale (PLA) */
    '\u{1F33F}': '<path d="M4.2 19.8c0-8 5-13 15.6-14 0 10.8-5 15-11.7 15a6 6 0 0 1-3.9-1z"/><path d="M4.2 19.8c2.8-3.9 5.8-6.1 9.7-7.6"/>',
    /* technique (nylon) */
    '⚙': '<circle cx="12" cy="12" r="3.1"/><path d="M12 2.6v2.6M12 18.8v2.6M21.4 12h-2.6M5.2 12H2.6M18.6 5.4l-1.8 1.8M7.2 16.8l-1.8 1.8M18.6 18.6l-1.8-1.8M7.2 7.2L5.4 5.4"/>',
    /* resistance aux chocs */
    '⚡': '<path d="M13.2 2.4L4.6 13.6h6.3L9.9 21.6l8.6-11.2h-6.4z"/>',
    /* decoratif */
    '\u{1F3A8}': '<path d="M12 21a9 9 0 1 1 9-9c0 2.1-1.7 3.2-3.4 3.2H16a2 2 0 0 0-1.4 3.4A1.9 1.9 0 0 1 12 21z"/><circle cx="7.6" cy="12.4" r="1"/><circle cx="9.9" cy="8.2" r="1"/><circle cx="14.8" cy="8" r="1"/>',
    /* piece fonctionnelle */
    '\u{1F527}': '<path d="M20.6 4.6l-3.1 3.1-2.4-2.4 3.1-3.1a5.4 5.4 0 0 0-7.3 7l-7.2 7.2a2 2 0 0 0 2.8 2.8l7.2-7.2a5.4 5.4 0 0 0 6.9-7.4z"/>',
    /* haute resistance */
    '\u{1F4AA}': '<path d="M12 2.9l7.4 3v6c0 4.3-3 7.5-7.4 9.2-4.4-1.7-7.4-4.9-7.4-9.2v-6z"/>',
    /* usage exterieur */
    '☀': '<circle cx="12" cy="12" r="4"/><path d="M12 2.2v2.4M12 19.4v2.4M2.2 12h2.4M19.4 12h2.4M5 5l1.7 1.7M17.3 17.3L19 19M19 5l-1.7 1.7M6.7 17.3L5 19"/>',
    /* souplesse */
    '\u{1FAE7}': '<path d="M3 12c0-3 2-5.2 4.5-5.2S12 9 12 12s2 5.2 4.5 5.2S21 15 21 12"/>',
    /* contact alimentaire */
    '\u{1F4A7}': '<path d="M12 3.1s6.1 5.9 6.1 10.1a6.1 6.1 0 0 1-12.2 0C5.9 9 12 3.1 12 3.1z"/>',
    /* resistance chimique */
    '\u{1F9EA}': '<path d="M9.4 2.8h5.2M10.6 2.8v6.4L5.4 18a2 2 0 0 0 1.7 3h9.8a2 2 0 0 0 1.7-3l-5.2-8.8V2.8"/><path d="M7.6 14.6h8.8"/>',
    /* haute temperature */
    '\u{1F321}': '<path d="M14 14.9V5.1a2 2 0 0 0-4 0v9.8a4 4 0 1 0 4 0z"/><path d="M12 8.8v6.6"/>',
    /* depot de fichier */
    '\u{1F4C1}': '<path d="M12 15.6V3.4M8 7.4l4-4 4 4"/><path d="M3.6 15.6v3a2 2 0 0 0 2 2h12.8a2 2 0 0 0 2-2v-3"/>',
    /* renforce */
    '\u{1F6E1}': '<path d="M12 2.9l7.4 3v6c0 4.3-3 7.5-7.4 9.2-4.4-1.7-7.4-4.9-7.4-9.2v-6z"/><path d="M9 12.2l2 2 4-4.3"/>',
    /* conception */
    '✏': '<path d="M4 20h4L20.1 7.9a2.8 2.8 0 0 0-4-4L4 16z"/><path d="M14.6 5.4l4 4"/>',
    /* fabrique en France */
    '\u{1F1EB}': '<path d="M5.2 21.2V3.4"/><path d="M5.2 4.2h13.4l-2.6 4.2 2.6 4.2H5.2z"/>'
  };

  /* Icône neutre si un émoji n'est pas encore cartographié : on ne laisse
     jamais un émoji survivre dans un conteneur d'icône. */
  var NEUTRE = '<path d="M12 3.6L20.4 12 12 20.4 3.6 12z"/>';

  var ALERTE = '<path d="M12 3.6L2.2 20.4h19.6z"/><path d="M12 9.8v4.4M12 17.3v.1"/>';

  /* Conteneurs qui n'ont qu'un émoji pour tout contenu. Le sélecteur est large
     à dessein : le garde estEmoji() plus bas empêche de toucher du vrai texte. */
  var CONTENEURS = [
    '.ico', '.t3d-res-emo', '.success-icon',
    '[class*="-ico"]', '[class*="__ico"]', '[class*="-icon"]', '[class*="__icon"]'
  ].join(',');

  /* Tout émoji connu croisé au fil du texte est retiré. Les conteneurs sont
     traités avant, donc leur contenu n'est plus du texte à ce moment-là. */
  var A_RETIRER = Object.keys(ICONES).concat([
    '\u{1F9F1}', '\u{1F4E7}', '\u{1F512}', '✨', '\u{1F4C2}',
    '⚠', '\u{1F680}', '\u{1F48E}', '\u{1F5A8}', '\u{1F4A1}',
    '\u{1F389}', '\u{1F44D}', '\u{1F449}', '❗', '⁉'
  ]);

  /* Un conteneur ne doit être remplacé que si son contenu EST un émoji.
     Sans ce garde, un sélecteur large transformerait un « OK » en losange. */
  function estEmoji(cp) {
    return (cp >= 0x1F300 && cp <= 0x1FAFF) ||
           (cp >= 0x2600 && cp <= 0x27BF && cp !== 0x2713 && cp !== 0x2714) ||
           (cp >= 0x1F1E6 && cp <= 0x1F1FF);
  }

  function premierPoint(txt) {
    if (!txt) return '';
    var cp = txt.codePointAt(0);
    return String.fromCodePoint(cp);
  }

  /* 1. Conteneurs d'icône -> SVG */
  function remplacerConteneurs(racine) {
    var els = (racine || doc).querySelectorAll(CONTENEURS);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.querySelector('svg')) continue;              /* déjà traité */
      var t = (el.textContent || '').trim();
      if (!t) continue;
      if (t.length > 6) continue;                          /* du vrai texte */

      var cle = premierPoint(t);
      if (!estEmoji(cle.codePointAt(0))) continue;   /* du texte, on n'y touche pas */
      var dessin = ICONES[cle];

      /* drapeau : deux indicateurs régionaux qui se suivent */
      if (!dessin && cle.codePointAt(0) >= 0x1F1E6 && cle.codePointAt(0) <= 0x1F1FF) {
        dessin = ICONES['\u{1F1EB}'];
      }
      if (!dessin) dessin = NEUTRE;

      el.innerHTML = svg(dessin);
      el.setAttribute('aria-hidden', 'true');
    }
  }

  /* 2. Émojis au fil du texte -> retirés */
  function nettoyerTexte(racine) {
    var zone = (racine || doc).querySelector('#MainContent') ||
               (racine || doc).querySelector('main') || (racine || doc);
    if (!zone.querySelectorAll) return;

    var marcheur = doc.createTreeWalker(zone, NodeFilter.SHOW_TEXT, null);
    var noeuds = [], n;
    while ((n = marcheur.nextNode())) noeuds.push(n);

    for (var i = 0; i < noeuds.length; i++) {
      var nd = noeuds[i];
      var p = nd.parentNode;
      if (!p) continue;
      var tag = p.nodeName;
      if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TEXTAREA') continue;
      if (p.closest && p.closest(CONTENEURS)) continue;

      var v = nd.nodeValue;
      if (!v) continue;
      var modifie = false;

      for (var k = 0; k < A_RETIRER.length; k++) {
        while (v.indexOf(A_RETIRER[k]) !== -1) {
          v = v.replace(A_RETIRER[k], '');
          modifie = true;
        }
      }
      if (!modifie) continue;

      /* sélecteur de variante orphelin + espaces doublés */
      while (v.indexOf('️') !== -1) v = v.replace('️', '');
      while (v.indexOf('  ') !== -1) v = v.replace('  ', ' ');
      nd.nodeValue = v;
    }
  }

  /* 3. Le message d'erreur perdait son signal en perdant son émoji : on lui
     rend un vrai pictogramme. */
  function marqueurAlerte(racine) {
    var els = (racine || doc).querySelectorAll('.rights-err, .form-err, .t3d-err');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.querySelector('svg')) continue;
      var s = doc.createElement('span');
      s.style.cssText = 'display:inline-block;margin-right:.5em;color:inherit';
      s.innerHTML = svg(ALERTE);
      el.insertBefore(s, el.firstChild);
    }
  }

  function passe(racine) {
    try {
      remplacerConteneurs(racine);
      nettoyerTexte(racine);
      marqueurAlerte(racine);
    } catch (e) {
      if (window.console) console.warn('[t3d-icons]', e);
    }
  }

  function demarrer() {
    passe(doc);
    /* Le configurateur construit des cartes après coup : on repasse quand le
       DOM bouge, sans jamais boucler sur nos propres écritures. */
    if (window.MutationObserver) {
      var enAttente = false;
      new MutationObserver(function () {
        if (enAttente) return;
        enAttente = true;
        setTimeout(function () { enAttente = false; passe(doc); }, 250);
      }).observe(doc.body, { childList: true, subtree: true });
    }
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }

  doc.addEventListener('shopify:section:load', function (e) { passe(e.target); });
})();